module.exports = __webpack_public_path__ + "img/prize.679c55d5.jpg";